<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="12" cy="12" r="8.25" stroke="currentColor" stroke-width="1.75" />
  <path
    d="M12 7.75V12L15 14.25"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
